import { CONFIG } from '../config';
import { supabase } from '../utils/supabaseClient';

const API_BASE_URL = CONFIG.API_URL;

async function getAccessToken() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) {
    const error = new Error('Connexion requise');
    error.code = 'AUTH_REQUIRED';
    throw error;
  }
  return token;
}

async function requestBillingJson(path, options = {}) {
  const token = await getAccessToken();
  const response = await fetch(`${API_BASE_URL}/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || data.error || `Erreur HTTP ${response.status}`);
    error.status = response.status;
    error.code = data.error;
    error.details = data;
    throw error;
  }

  return data;
}

export async function getBillingState() {
  return requestBillingJson('/billing/me', { method: 'GET' });
}

export async function verifyGooglePlayPurchase({ productId, purchaseToken }) {
  return requestBillingJson('/android-billing/google-play/verify', {
    method: 'POST',
    body: JSON.stringify({ productId, purchaseToken }),
  });
}

export async function createStripeCheckoutSession({ tier, returnTo = null }) {
  return requestBillingJson('/web-billing/stripe/checkout-session', {
    method: 'POST',
    body: JSON.stringify({ tier, returnTo }),
  });
}

export async function createStripePortalSession({ tier = null, returnTo = null } = {}) {
  const payload = {};
  if (tier) payload.tier = tier;
  if (returnTo) payload.returnTo = returnTo;

  return requestBillingJson('/web-billing/stripe/portal-session', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function syncStripeCheckoutSession({ sessionId }) {
  return requestBillingJson('/web-billing/stripe/sync-checkout-session', {
    method: 'POST',
    body: JSON.stringify({ sessionId }),
  });
}
